// File: /src/components/finance/FinanceDashForm.js

import React, { useState } from 'react';
import { toast } from 'react-toastify';
import '../../styles/finance/FinanceDashForm.css';
import '../../styles/ModalStyle.css';

const FinanceDashForm = ({
	form,
	handleInputChange,
	addOrUpdateFinanceEntry,
	closeModal,
	editingEntry,
}) => {
	const [dateError, setDateError] = useState('');
	const [dateInputValue, setDateInputValue] = useState(() => {
		if (!form.date) return '';
		if (form.date instanceof Date) {
			return form.date.toLocaleDateString('pt-BR');
		}
		try {
			const date = new Date(form.date);
			return date.toLocaleDateString('pt-BR');
		} catch (e) {
			return '';
		}
	});

	const formatDateInput = (value) => {
		const digits = value.replace(/\D/g, '');
		let formatted = digits;
		if (digits.length > 2) {
			formatted = digits.slice(0, 2) + '/' + digits.slice(2);
		}
		if (digits.length > 4) {
			formatted =
				digits.slice(0, 2) +
				'/' +
				digits.slice(2, 4) +
				'/' +
				digits.slice(4, 8);
		}
		return formatted;
	};

	const validateDate = (dateStr) => {
		if (dateStr.length === 0) return true;
		const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
		if (!regex.test(dateStr)) return false;
		const [, day, month, year] = dateStr.match(regex);
		const date = new Date(year, month - 1, day);
		return (
			date &&
			date.getFullYear() === Number(year) &&
			date.getMonth() === Number(month) - 1 &&
			date.getDate() === Number(day)
		);
	};

	const handleDateChange = (e) => {
		const rawValue = e.target.value;
		const formattedValue = formatDateInput(rawValue);
		setDateInputValue(formattedValue);

		if (!validateDate(formattedValue)) {
			setDateError('Data inválida');
			handleInputChange({
				target: { name: 'date', value: null },
			});
		} else {
			setDateError('');
			if (formattedValue.length === 10) {
				const [day, month, year] = formattedValue.split('/');
				const date = new Date(year, month - 1, day);
				handleInputChange({
					target: { name: 'date', value: date },
				});
			}
		}
	};

	const validateForm = (e) => {
		e.preventDefault();

		const value = parseFloat(form.value);
		if (isNaN(value) || value <= 0) {
			toast.error('Por favor, insira um valor válido maior que zero.');
			return;
		}

		if (!form.date) {
			toast.error('Por favor, insira uma data válida.');
			return;
		}

		addOrUpdateFinanceEntry(e);
	};

	return (
		<form
			className="finance-dash-form"
			onSubmit={validateForm}
			autoComplete="off"
		>
			<>
				<h2 className="form-title">
					{editingEntry ? 'EDITAR ENTRADA' : 'ADICIONAR ENTRADA'}
				</h2>

				{/* Descrição */}
				<textarea
					name="description"
					placeholder="Descrição"
					value={form.description ?? ''}
					onChange={handleInputChange}
					rows={3}
				/>

				{/* Valor */}
				<input
					name="value"
					type="number"
					step="0.01"
					placeholder="Valor (R$)"
					value={form.value}
					onChange={handleInputChange}
					required
				/>

				{/* Tipo: income/expense */}
				<select
					name="type"
					value={form.type}
					onChange={handleInputChange}
					required
				>
					<option value="income">Receita</option>
					<option value="expense">Despesa</option>
				</select>

				{/* Data */}
				<div className="date-input-container">
					<input
						name="date"
						type="text"
						placeholder="Data (DD/MM/AAAA)"
						value={dateInputValue}
						onChange={handleDateChange}
						required
						autoComplete="off"
					/>
					{dateError && (
						<span className="date-error">{dateError}</span>
					)}
				</div>

				<button type="submit">
					{editingEntry ? 'SALVAR ALTERAÇÕES' : 'ADICIONAR ENTRADA'}
				</button>
			</>
		</form>
	);
};

export default FinanceDashForm;
